export default __webpack_public_path__ + "static/media/button-apple.f9dd0f3c.png";